// import React from "react";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { Line } from "react-chartjs-2";
// import { useSelector } from "react-redux";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend
// );

// export const options = {
//   responsive: true,
//   interaction: {
//     mode: "index",
//     intersect: false,
//   },
//   stacked: false,
//   //   plugins: {
//   //     title: {
//   //       display: true,
//   //       text: "Approved Sender Id Types",
//   //     },
//   //   },
//   scales: {
//     y: {
//       type: "linear",
//       display: true,
//       position: "left",
//     },
//     y1: {
//       type: "linear",
//       display: true,
//       position: "right",
//       grid: {
//         drawOnChartArea: false,
//       },
//     },
//   },
// };

// const labels = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
// ];

// export const data = {
//   labels,
//   datasets: [
//     {
//       label: "Pending for Approval",
//       data: [65, 29, 80, 31, 56, 39, 41, 65, 22, 89, 81],
//       borderColor: "#39CCCC",
//       // backgroundColor: "rgb(0,0,135)",
//       backgroundColor: "#39CCCC",
//       yAxisID: "y",
//       tension: 0.5,
//     },
//     {
//       label: "Active",
//       data: [76, 29, 92, 61, 60, 52, 46, 87, 59, 90, 81],
//       borderColor: "#D81B60",
//       // backgroundColor: "rgb(117,217,239)",
//       backgroundColor: "#D81B60",
//       yAxisID: "y1",
//       tension: 0.5,
//     },
//     {
//       label: "In Process",
//       data: [50, 17, 60, 44, 26, 14, 29, 15, 59, 89, 51],
//       borderColor: "#FF851B",
//       // backgroundColor: "rgb(80,108,120)",
//       backgroundColor: "#FF851B",
//       yAxisID: "y1",
//       tension: 0.5,
//     },
//     {
//       label: "Rejected",
//       data: [10, 9, 37, 41, 21, 28, 11, 35, 24, 67, 61],
//       borderColor: "#605CA8)",
//       // backgroundColor: "rgb(216,217,221)",
//       backgroundColor: "#605CA8",
//       yAxisID: "y1",
//       tension: 0.5,
//     },
//   ],
// };

// export function MultiLineGraph({ value: localData }) {
//   const globalData = useSelector((state) => state.dashboardReducer);

//   return <Line options={options} data={data} />;
// }

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  Chart,
  getElementsAtEvent,
  getDatasetAtEvent,
  getElementAtEvent,
} from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useState, useRef } from "react";
import { Backdrop, Button, Skeleton } from "@mui/material";
import Loader from "../../../components/Loader";
import moment from "moment";
import { common_axios } from "../../../App";
import Swal from "sweetalert2";
import DateRangeIcon from "@mui/icons-material/DateRange";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import CancelImg from "../../../assets/images/cancel.png";
import { setTimeSeries1 } from "../../../redux/features/dashboardSlice";
import { actionid } from "../../../redux/features/pageSlices";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const generateLegendHtml = (chart) => {
  const { datasets } = chart.data;
  let legendHtml = "";

  datasets.forEach((dataset, index) => {
    const backgroundColor = dataset.backgroundColor[index];
    const label = dataset.label;

    // console.log({ label });

    legendHtml += `
      <div class="custom-legend">
        <span class="legend-color" style="background-color: ${backgroundColor}"></span>
        <span class="legend-label">${label}</span>
      </div>
    `;
  });

  return "this";
};

export function MultiLineGraph({ value  }) {
  const dispatch = useDispatch();
  const resd = useSelector((data) => data?.dashboardReducer);
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(true);
  const chartRef = useRef();
  const history = useHistory();
  const handleLegendClick = (event, legendItem) => {
    // Access the clicked legend item
    // console.log(legendItem, event);
    legendItem.hidden = true;
  };

  const options = {
    responsive: true,
    interaction: {
      mode: "index",
      intersect: false,
    },

    legend: {
      // display: false,
      // onClick: handleLegendClick,
    },
    stacked: false,
    //   plugins: {
    //     title: {
    //       display: true,
    //       text: "Approved Sender Id Types",
    //     },
    //   },

    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: (xDatapoint) => {
            if (isNaN(xDatapoint?.[0].label)) {
              return xDatapoint?.[0].label;
            } else {
              // var dateObj = new Date();
              // var month1 = dateObj.getUTCMonth() + 1; //months from 1-12
              // var year = dateObj.getUTCFullYear();

              // const newdate = xDatapoint?.[0].label + "/" + month1 + "/" + year;

              // return newdate;

              return data?.labelsName?.[xDatapoint?.[0]?.dataIndex];
            }
          },
          // label: (yDatapoint) => {
          //   console.log({ yDatapoint }); // All list shown in color
          //   return "22";
          // },
        },
      },
      datalabels: {
        display: true,
        color: "transparent",
        align: "top",
        padding: {
          right: 2,
        },
        labels: {
          padding: { top: 10 },
          title: {
            font: {
              weight: "bold",
            },
          },
          value: {
            color: "transparent",
          },
        },
        formatter: function (value) {
          return "\n" + value;
        },
      },
    },

    onHover: (event, activeElements) => {
      // console.log({ activeElements });
      if (activeElements?.length > 0) {
        event.native.target.style.cursor = "pointer";
      } else {
        event.native.target.style.cursor = "auto";
      }
    },
    scales: {
      y: {
        type: "linear",
        display: true,
        position: "left",
        ticks: {
          min: 0,
          max: 1,
          stepSize: 1,
          fontSize: 20,
        },
        title: {
          display: true,
          text: "<---- Count ---->",
          // color: "#911",
          font: {
            family: "Poppins, sans-serif",
            size: 20,
            weight: "bolder",
            lineHeight: 1.2,
          },
        },
      },
      x: {
        stacked: true,
        maxTicksLimit: 11,
        title: {
          display: true,
          text: `<---- ${value === "Daily" ? "Date" : "Month"} ---->`,
          font: {
            family: "Poppins, sans-serif",
            size: 20,
            weight: "bolder",
            lineHeight: 1.2,
          },
        },
      },
      // x1: {
      //   ticks: {
      //     // For a category axis, the val is the index so the lookup via getLabelForValue is needed
      //     callback: function (val, index) {
      //       // Hide every 2nd tick label
      //       console.log(
      //         "TTTTTTTT",
      //         Math.floor(data?.labels?.length / 2),
      //         index,
      //         Math.floor(data?.labels?.length / 2) === index,
      //         data
      //       );
      //       return Math.floor(data?.labels?.length / 2) === index
      //         ? "Campaign Type"
      //         : null;
      //     },
      //   },
      // },

      // y1: {
      //   type: "linear",
      //   display: true,
      //   position: "right",
      //   grid: {
      //     drawOnChartArea: false,
      //   },
      // },
    },
  };

  const assignUserApi = async (e) => {
    var date = moment(resd?.timeSeries?.end);
    var now = moment(resd?.timeSeries?.start);
    var duration = moment.duration(date.diff(now));
    var noofDays = duration.asDays();
    if (value == "Daily") {
      try {
        setOpen(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/multiline/graph/day-wise/count`,
          {
            campaignRequest: {
              startDateTime: `${resd?.timeSeries?.end}`,
              endDateTime: `${resd?.timeSeries?.start}`,
            },
            role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
          }
        );

        if (res.data?.statusDescription?.statusCode == 200) {
          // setData1(res.data);

          if (res.data?.dataSets?.length == 0) {
            setData([]);
          } else {
            res.data["dataSets1"] = [];
            let varrr = false;
            for (let index = 0; index < res.data?.dataSets.length; index++) {
              res.data.dataSets[index]["pointRadius"] = 0;
              res.data.dataSets[index]["clicked"] = true;

              if (res.data.dataSets[index].label == "Scheduled") {
                res.data.dataSets[index]["backgroundColor"] = "blue";
                res.data.dataSets[index]["borderColor"] = "blue";
                res.data.dataSets[index]["icon"] = DateRangeIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] =
                "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index][
                "pointHoverRadius"
              ] = 6;
           
              res.data.dataSets[index][
                "pointBackgroundColor"
              ] = "white";
              res.data.dataSets[index]["pointBorderColor"] =
                "blue";
              }
              if (res.data.dataSets[index].label == "Stopped") {
                res.data.dataSets[index]["backgroundColor"] = "#f9442f";
                res.data.dataSets[index]["borderColor"] = "#f9442f";
                res.data.dataSets[index]["icon"] = StopCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] =
                "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index][
                "pointHoverRadius"
              ] = 6;
             
              res.data.dataSets[index][
                "pointBackgroundColor"
              ] = "white";
              res.data.dataSets[index]["pointBorderColor"] =
                "#f9442f";
              }
              if (res.data.dataSets[index].label == "Completed") {
                res.data.dataSets[index]["backgroundColor"] = "#5ab778";
                res.data.dataSets[index]["borderColor"] = "#5ab778";
                res.data.dataSets[index]["icon"] = CheckCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] =
                "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index][
                "pointHoverRadius"
              ] = 6;
            
              res.data.dataSets[index][
                "pointBackgroundColor"
              ] = "white";
              res.data.dataSets[index]["pointBorderColor"] =
                "#5ab778";
              }

              for (
                let i = 0;
                i < res.data?.dataSets[index]?.data?.length;
                i++
              ) {
                if (res.data?.dataSets[index]?.data[i] != 0) {
                  varrr = true;
                }
              }
            }
            if (!varrr) {
              setData([]);
            } else {
              if (value == "Daily") {
                setData({
                  labels: res.data?.xaxisLabelDate,
                  labelsName: res.data?.xaxisLabelDate,
                  labelsNumber: res.data?.xaxisLabels,
                  datasets: res.data?.dataSets1,
                  // datasets: [
                  //   {
                  //     label: "Pending for Approval",
                  //     data: [65, 29, 80, 31, 56, 39, 41, 65, 22, 89, 81],
                  //     borderColor: "#39CCCC",
                  //     // backgroundColor: "rgb(0,0,135)",
                  //     backgroundColor: "#39CCCC",
                  //     yAxisID: "y",
                  //     tension: 0.5,
                  //   },
                  //   {
                  //     label: "Active",
                  //     data: [76, 29, 92, 61, 60, 52, 46, 87, 59, 90, 81],
                  //     borderColor: "#D81B60",
                  //     // backgroundColor: "rgb(117,217,239)",
                  //     backgroundColor: "#D81B60",
                  //     yAxisID: "y1",
                  //     tension: 0.5,
                  //   },
                  //   {
                  //     label: "In Process",
                  //     data: [50, 17, 60, 44, 26, 14, 29, 15, 59, 89, 51],
                  //     borderColor: "#FF851B",
                  //     // backgroundColor: "rgb(80,108,120)",
                  //     backgroundColor: "#FF851B",
                  //     yAxisID: "y1",
                  //     tension: 0.5,
                  //   },
                  //   {
                  //     label: "Rejected",
                  //     data: [10, 9, 37, 41, 21, 28, 11, 35, 24, 67, 61],
                  //     borderColor: "#605CA8)",
                  //     // backgroundColor: "rgb(216,217,221)",
                  //     backgroundColor: "#605CA8",
                  //     yAxisID: "y1",
                  //     tension: 0.5,
                  //   },
                  // ],
                });
              }
            }
          }
          setOpen(false);
        } else {
          setData([]);
          setOpen(false);
        }
      } catch (error) {
        setData([]);
        setOpen(false);
        // console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } else {
      try {
        setOpen(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/multiline/graph/month-wise/count`,
          {
            campaignRequest: {
              startDateTime: `${resd?.timeSeries?.end}`,
              endDateTime: `${resd?.timeSeries?.start}`,
            },
            role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
          }
        );

        if (res.data?.statusDescription.statusCode == 200) {
          if (res.data?.dataSets?.length == 0) {
            setData([]);
          } else {
            let varrr = false;
            res.data["dataSets1"] = [];
            for (let index = 0; index < res.data?.dataSets?.length; index++) {
              res.data.dataSets[index]["pointRadius"] = 0;
              res.data.dataSets[index]["clicked"] = true;

              if (res.data.dataSets[index].label == "Scheduled") {
                res.data.dataSets[index]["backgroundColor"] = "blue";
                res.data.dataSets[index]["borderColor"] = "blue";
                res.data.dataSets[index]["icon"] = DateRangeIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] =
                "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index][
                "pointHoverRadius"
              ] = 6;
            
              res.data.dataSets[index][
                "pointBackgroundColor"
              ] = "white";
              res.data.dataSets[index]["pointBorderColor"] =
                "blue";
              }

              if (res.data.dataSets[index].label == "Stopped") {
                res.data.dataSets[index]["backgroundColor"] = "#f9442f";
                res.data.dataSets[index]["borderColor"] = "#f9442f";
                res.data.dataSets[index]["icon"] = StopCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] =
                "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index][
                "pointHoverRadius"
              ] = 6;
              
              res.data.dataSets[index][
                "pointBackgroundColor"
              ] = "white";
              res.data.dataSets[index]["pointBorderColor"] =
                "#f9442f";
              }
              if (res.data.dataSets[index].label == "Completed") {
                res.data.dataSets[index]["backgroundColor"] = "#5ab778";
                res.data.dataSets[index]["borderColor"] = "#5ab778";
                res.data.dataSets[index]["icon"] = CheckCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] =
                "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index][
                "pointHoverRadius"
              ] = 6;
              // res.data.dataSets[index][
              //   "pointHoverBackgroundColor"
              // ] = "white";
              res.data.dataSets[index][
                "pointBackgroundColor"
              ] = "white";
              res.data.dataSets[index]["pointBorderColor"] =
                "#5ab778";
              }
              for (
                let i = 0;
                i < res.data?.dataSets[index]?.data?.length;
                i++
              ) {
                if (res.data?.dataSets[index]?.data[i] != 0) {
                  varrr = true;
                }
              }
            }
            if (!varrr) {
              setData([]);
            } else {
              if (value != "Daily") {
                setData({
                  labels: res.data?.xaxixLabels,

                  datasets: res.data?.dataSets1,
                });
              }
            }
          }
          setOpen(false);
        } else {
          setData([]);
          setOpen(false);
        }
      } catch (error) {
        // console.error({ error });

        setData([]);
        setOpen(false);
        // console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    }
  };

  useEffect(() => {
    assignUserApi();
  }, [
    resd?.timeSeries?.start,
    resd?.timeSeries?.end,
    resd?.product,
    resd?.productType,
    // resd?.showBy,
    value,
  ]);

  const globalData = useSelector((state) => state.dashboardReducer);

  const printDatasetAtEvent = (dataset) => {
    if (!dataset.length) return;

    const datasetIndex = dataset[0].datasetIndex;

    // console.log(data.datasets[datasetIndex].status);

    return data.datasets[datasetIndex].status;
  };

  const printElementAtEvent = (element) => {
    if (!element.length) return;

    const { datasetIndex, index } = element[0];

    // console.log(data.labels[index], data.datasets[datasetIndex].data[index]);
    return data.labels[index];
  };

  const printElementsAtEvent = (elements) => {
    if (!elements.length) return;

    // console.log(elements.length);
    return elements.length;
  };

  const printElementIndexAtEvent = (element) => {
    if (!element.length) return;

    const { datasetIndex, index } = element[0];

    return [index];
  };

  const handleClick = (event) => {
    // alert("Now clikced");

    // console.log(
    //   "IIIIIIII",
    //   printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event)),
    //   printElementAtEvent(getElementAtEvent(chartRef.current, event)),
    //   !isNaN(
    //     data?.labelsNumber?.[
    //       printElementIndexAtEvent(getElementAtEvent(chartRef.current, event))
    //     ]
    //   )
    // );
    var dateObj = new Date();
    var month1 = dateObj.getUTCMonth() + 1; //months from 1-12
    var year = dateObj.getUTCFullYear();

    const newdate =
      year +
      "-" +
      month1 +
      "-" +
      printElementAtEvent(getElementAtEvent(chartRef.current, event));

    // if (printElementAtEvent(getElementAtEvent(chartRef.current, event))) {
    //   localStorage?.setItem(
    //     "dstQueCode1",
    //     `${newdate},${printDatasetAtEvent(
    //       getDatasetAtEvent(chartRef.current, event)
    //     )}`
    //   );

    // }

    if (
      // !isNaN(printElementAtEvent(getElementAtEvent(chartRef.current, event)))
      !isNaN(
        data?.labelsNumber?.[
          printElementIndexAtEvent(getElementAtEvent(chartRef.current, event))
        ]
      )
    ) {
      var dateObj = new Date();
      var month1 = dateObj.getUTCMonth() + 1; //months from 1-12
      var year = dateObj.getUTCFullYear();

      const newdate =
        year +
        "-" +
        month1 +
        "-" +
        printElementAtEvent(getElementAtEvent(chartRef.current, event));

      if (printElementAtEvent(getElementAtEvent(chartRef.current, event))) {
        // localStorage?.setItem(
        //   "dstQueCode1",
        //   `${newdate},${printDatasetAtEvent(
        //     getDatasetAtEvent(chartRef.current, event)
        //   )},${value}`
        // );

        localStorage?.setItem(
          "dstQueCode1",
          `${
            data?.labelsName?.[
              printElementIndexAtEvent(
                getElementAtEvent(chartRef.current, event)
              )
            ]
          },${printDatasetAtEvent(
            getDatasetAtEvent(chartRef.current, event)
          )},${value}`
        );

        if (
          printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event)) == 1
        ) {
          if (
            JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
            "ROLE_SUPER_ADMIN"
          ) {
            dispatch(actionid("1"));
            document
              .getElementsByName("sidebarLiCampaign Manager")?.[0]
              ?.click();
            history.replace("/dashboard/CampaignsControl");
          } else {
            dispatch(actionid("1"));
            document
              .getElementsByName("sidebarLiCampaign Manager")?.[0]
              ?.click();
            history.replace("/dashboard/CampaignControl");
          }
        } else {
          dispatch(
            setTimeSeries1({
              end: `${
                data?.labelsName?.[
                  printElementIndexAtEvent(
                    getElementAtEvent(chartRef.current, event)
                  )
                ]
              }`,
              start: `${
                data?.labelsName?.[
                  printElementIndexAtEvent(
                    getElementAtEvent(chartRef.current, event)
                  )
                ]
              }`,
              dateType: "Daily",
              approveType:
                printDatasetAtEvent(
                  getDatasetAtEvent(chartRef.current, event)
                ) == 5
                  ? "Stopped"
                  : "Completed",
            })
          );
          document.getElementsByName("sidebarLiReports")?.[0]?.click();
          history?.push("/dashboard/TransactionalReport");
        }
      } else {
      }
    } else {
      // console.log(
      //   "PPPPPP",

      //   moment()
      //     .month(
      //       printElementAtEvent(getElementAtEvent(chartRef.current, event))
      //     )
      //     .format("M"),
      //   moment().format("M"),
      //   typeof moment().month("feb").format("M")
      // );

      if (
        Number(
          moment()
            .month(
              printElementAtEvent(getElementAtEvent(chartRef.current, event))
            )
            .format("M")
        ) <= Number(moment().format("M"))
      ) {
        const endDate = moment(
          moment().month(
            printElementAtEvent(getElementAtEvent(chartRef.current, event))
          )
        )
          .endOf("month")
          .format("YYYY-MM-DD");
        const startDate = moment(
          moment().month(
            printElementAtEvent(getElementAtEvent(chartRef.current, event))
          )
        )
          .startOf("month")
          .format("YYYY-MM-DD");
        localStorage?.setItem(
          "dstQueCode1",
          `${startDate},${printDatasetAtEvent(
            getDatasetAtEvent(chartRef.current, event)
          )},${value},${endDate}`
        );
        if (getDatasetAtEvent(chartRef.current, event) == 1) {
          if (
            JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
            "ROLE_SUPER_ADMIN"
          ) {
            dispatch(actionid("1"));
            document
              .getElementsByName("sidebarLiCampaign Manager")?.[0]
              ?.click();
            history.replace("/dashboard/CampaignsControl");
          } else {
            dispatch(actionid("1"));
            document
              .getElementsByName("sidebarLiCampaign Manager")?.[0]
              ?.click();
            history.replace("/dashboard/CampaignControl");
          }
        } else {
          dispatch(
            setTimeSeries1({
              end: `${endDate}`,
              start: `${startDate}`,
              dateType: "Daily",
              approveType:
                printDatasetAtEvent(
                  getDatasetAtEvent(chartRef.current, event)
                ) == 5
                  ? "Stopped"
                  : "Completed",
            })
          );
          document.getElementsByName("sidebarLiReports")?.[0]?.click();
          history?.push("/dashboard/TransactionalReport");
        }
      } else {
        const endDate = moment(
          moment(
            moment().month(
              printElementAtEvent(getElementAtEvent(chartRef.current, event))
            )
          ).endOf("month")
        )
          .add(-1, "y")
          .format("YYYY-MM-DD");
        const startDate = moment(
          moment(
            moment().month(
              printElementAtEvent(getElementAtEvent(chartRef.current, event))
            )
          ).startOf("month")
        )
          .add(-1, "y")
          .format("YYYY-MM-DD");

        localStorage?.setItem(
          "dstQueCode1",
          `${startDate},${printDatasetAtEvent(
            getDatasetAtEvent(chartRef.current, event)
          )},${value},${endDate}`
        );
        if (getDatasetAtEvent(chartRef.current, event) == 1) {
          if (
            JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
            "ROLE_SUPER_ADMIN"
          ) {
            dispatch(actionid("1"));
            document
              .getElementsByName("sidebarLiCampaign Manager")?.[0]
              ?.click();
            history.replace("/dashboard/CampaignsControl");
          } else {
            dispatch(actionid("1"));
            document
              .getElementsByName("sidebarLiCampaign Manager")?.[0]
              ?.click();
            history.replace("/dashboard/CampaignControl");
          }
        } else {
          dispatch(
            setTimeSeries1({
              end: `${endDate}`,
              start: `${startDate}`,
              dateType: "Daily",
              approveType:
                printDatasetAtEvent(
                  getDatasetAtEvent(chartRef.current, event)
                ) == 5
                  ? "Stopped"
                  : "Completed",
            })
          );
          document.getElementsByName("sidebarLiReports")?.[0]?.click();
          history?.push("/dashboard/TransactionalReport");
        }
      }
    }

    // history?.push("/dashboard/TransactionalReports");
    // printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event));
    // printElementAtEvent(getElementAtEvent(chartRef.current, event));
    // printElementsAtEvent(getElementsAtEvent(chartRef.current, event));
  };

  const handleButtonClick = (index) => {
    // console.log(chartRef.current.data.dataset);
    let dataaa = [...data?.datasets];
    dataaa[index].clicked = !dataaa[index].clicked;
    setData({
      ...data,
      datasets: dataaa,
    });
    chartRef.current.data.datasets[index].hidden =
      !chartRef.current.data.datasets[index].hidden;
    chartRef.current.update();
  };

  return (
    <>
      {/* <Backdrop
        sx={{
          transform: "translateZ(0)",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
        // onClick={handleClose}
      >
        <Loader />
      </Backdrop> */}
      {!open && data ? (
        <>
          {data.length == 0 ? (
            <div className="d-flex h-100 p-3">
              <div className="m-auto text-center">
                <h1>No Data</h1>
                <img
                  style={{ width: "100px", maxWidth: "100%" }}
                  src={CancelImg}
                  alt=""
                  srcset=""
                />
              </div>
            </div>
          ) : (
            <>
              <div className="d-flex flex-wrap justify-content-center mt-2">
                {data?.datasets?.map((dataaa, index) => {
                  return (
                    <div>
                      {/* <button
                        className="btn btn-primary me-2"
                        style={{
                          backgroundColor: dataaa.backgroundColor,
                          textDecorationColor: "black",
                          textDecoration: chartRef?.current?.data?.datasets?.[
                            index
                          ]?.hidden
                            ? "line-through"
                            : "none",
                          color: "white",
                        }}
                        onClick={() => {
                          handleButtonClick(index);
                        }}
                      >
                        {dataaa?.label}
                      </button> */}
                      <Button
                        className="me-3"
                        size="small"
                        sx={{
                          borderRadius: 2,
                          boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
                          backgroundColor: chartRef?.current?.data?.datasets?.[
                            index
                          ]?.hidden
                            ? "grey"
                            : dataaa.backgroundColor,
                          color: "white",
                          textDecorationColor: "black",
                          textDecoration: chartRef?.current?.data?.datasets?.[
                            index
                          ]?.hidden
                            ? "line-through"
                            : "none",
                          color: "white",
                        }}
                        variant="contained"
                        startIcon={
                          dataaa.icon ? <dataaa.icon /> : <CheckCircleIcon />
                        }
                        onClick={() => {
                          handleButtonClick(index);
                        }}
                      >
                        {dataaa?.label}
                      </Button>
                    </div>
                  );
                })}
              </div>
              <Chart
                type="line"
                options={options}
                data={data}
                onClick={handleClick}
                ref={chartRef}
              />
            </>
          )}
        </>
      ) : (
        <>
          <Skeleton animation="wave" className="mt-3" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </>
      )}
    </>
  );
}
